import React, {useState} from 'react';

import css from './SampleMenuComponent.module.css';
import SampleMenuListComponent from "../SampleMenuListComponent/SampleMenuListComponent";
import {SelectSampleMenuModal} from "../menuSectionModals";


const SampleMenuComponent = () => {
    const [isOpen, setIsOpen] = useState(false);


    return (
        <section className={css.wrap}>

            <section className={css.blockInfo}>
                <SampleMenuListComponent setIsOpen={setIsOpen}/>
            </section>

            {isOpen && <SelectSampleMenuModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {SampleMenuComponent};